import { compose, lifecycle, withHandlers, withProps, withState } from 'recompose';
import { connect } from 'react-redux';
import moment from 'moment';

import { getTimezone } from '../../../../auth/selectors';
import { fetchOwnerReport } from '../actions';
import { getIsFetching } from '../selectors';
import withActiveUserIdAndType from '../../../../common/hoc/withActiveUserIdAndType';
import withDefaultEndingDate from '../../../reports/filters/containers/withDefaultEndingDate';
import Filters from '../../../reports/filters/components/Filters';

const RangeFilterContainer = compose(
  withActiveUserIdAndType({ useShopForBarber: true }),
  withDefaultEndingDate(),
  connect(
    state => ({
      timezone: getTimezone(state),
      isFetching: getIsFetching(state),
    }),
    { fetchOwnerReport }
  ),
  withState('startDate', 'setStartDate', moment.utc().subtract(6, 'days').toDate()),
  withState('endDate', 'setEndDate', moment.utc().toDate()),
  withHandlers({
    onDateChange: props => (from, to) => {
      props.setStartDate(from);
      props.setEndDate(to);
    },
    onSubmit: props => () => {
      if (props.isFetching) return;
      props.fetchOwnerReport(props.activeId, props.activeType, props.startDate, props.endDate, props.timezone);
    },
  }),
  lifecycle({
    componentDidMount() {
      this.props.onSubmit();
    },
  }),
  withProps(props => ({
    end: props.endingDateMax,
    disabled: props.isFetching,
    range: true,
    applyFilter: props.onSubmit,
    disableBarberFilter: true,
    showCsvExport: false,
    from: null,
    to: moment.utc().toDate(),
  })),
);

export default RangeFilterContainer(Filters);
